import type { StudentWorksheet } from 'src/dto'

export const SCORING_TARGET_QUERY_PARAM = 'studentWorksheetId'

export const parseScoringTargetId = (search: string): StudentWorksheet['id'] | undefined => {
  const raw = new URLSearchParams(search).get(SCORING_TARGET_QUERY_PARAM)
  if (raw === null) return

  const id = Number(raw)
  if (!Number.isInteger(id) || id <= 0) return
  return id
}

// QR 로 연 채점 시트에만 [다음 QR 스캔] 을 둔다
const ENTRY_QUERY_PARAM = 'from'
const QR_ENTRY = 'qr'

export const QR_SCORING_ENTRY_QUERY = `${ENTRY_QUERY_PARAM}=${QR_ENTRY}`

export const isQrScoringEntry = (search: string) =>
  new URLSearchParams(search).get(ENTRY_QUERY_PARAM) === QR_ENTRY
